export const SET_BOXES = (state, payload) => {
  state.boxes = payload;
}
export const LOADING = (state, payload) => {
  state.loading = payload;
}